// Minimal i18n (SK + EN)
import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  sk: {
    app_name: "Vue",
    tagline: "Jeden panel. Všetky tvoje účty.",
    login: "Prihlásiť sa",
    logout: "Odhlásiť",
    email: "Email",
    password: "Heslo",
    sign_in: "Prihlásiť",
    register: "Registrovať",
    dashboard: "Prehľad",
    inbox: "Schránka",
    fans: "Fanúšikovia",
    vault: "Trezor fotiek",
    ai_settings: "AI nastavenia",
    mass_message: "Hromadná správa",
    connections: "Prepojenia",
    settings: "Nastavenia",
    total_revenue: "Celkové príjmy",
    total_tips: "Tipy spolu",
    fans_count: "Počet fanúšikov",
    messages_count: "Správ celkom",
    nsfw_unlocked: "NSFW odomknuté",
    top_fans: "Top fanúšikovia",
    recent_activity: "Posledná aktivita",
    seed_demo: "Načítať ukážkové dáta",
    seed_demo_hint: "Vytvorí pár fanov a konverzácií pre testovanie.",
    fanvue_chat: "Fanvue chat",
    other_platform: "Druhá platforma",
    write_message: "Napíš správu...",
    send: "Odoslať",
    ai_draft: "AI návrh",
    use_draft: "Použiť návrh",
    auto_reply: "Auto-odpovede",
    auto_reply_hint: "Bot 24/7 odpovedá automaticky.",
    nsfw_threshold: "NSFW prah ($)",
    custom_persona: "Vlastná persona (override)",
    default_language: "Predvolený jazyk",
    save: "Uložiť",
    saved: "Uložené",
    test_ai: "Test AI",
    test_message: "Skúšobná správa",
    fanvue: "Fanvue",
    telegram: "Telegram",
    instagram: "Instagram",
    x: "X (Twitter)",
    connect: "Pripojiť",
    disconnect: "Odpojiť",
    connected: "Pripojené",
    not_connected: "Nepripojené",
    spend: "Útrata",
    new_chat: "Nová konverzácia",
    add_photo: "Pridať fotku",
    title: "Názov",
    price: "Cena",
    nsfw: "NSFW",
    upload: "Nahrať",
    offer_photo: "Ponúknuť fotku",
    no_fans_yet: "Zatiaľ žiadni fanúšikovia.",
    no_messages: "Zatiaľ žiadne správy.",
    rules: "Pravidlá persony",
    welcome_back: "Vitaj späť",
    enter_creator_panel: "Vstúp do panelu kreátorky",
    language: "Jazyk",
  },
  en: {
    app_name: "Vue",
    tagline: "One panel. All your accounts.",
    login: "Sign in",
    logout: "Sign out",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    register: "Register",
    dashboard: "Overview",
    inbox: "Inbox",
    fans: "Fans",
    vault: "Photo vault",
    ai_settings: "AI settings",
    mass_message: "Mass message",
    connections: "Connections",
    settings: "Settings",
    total_revenue: "Total revenue",
    total_tips: "Total tips",
    fans_count: "Fans",
    messages_count: "Messages",
    nsfw_unlocked: "NSFW unlocked",
    top_fans: "Top fans",
    recent_activity: "Recent activity",
    seed_demo: "Seed demo data",
    seed_demo_hint: "Create sample fans and conversations to play with.",
    fanvue_chat: "Fanvue chat",
    other_platform: "Other platform",
    write_message: "Write a message...",
    send: "Send",
    ai_draft: "AI draft",
    use_draft: "Use draft",
    auto_reply: "Auto-reply",
    auto_reply_hint: "Bot answers automatically 24/7.",
    nsfw_threshold: "NSFW threshold ($)",
    custom_persona: "Custom persona (override)",
    default_language: "Default language",
    save: "Save",
    saved: "Saved",
    test_ai: "Test AI",
    test_message: "Test message",
    fanvue: "Fanvue",
    telegram: "Telegram",
    instagram: "Instagram",
    x: "X (Twitter)",
    connect: "Connect",
    disconnect: "Disconnect",
    connected: "Connected",
    not_connected: "Not connected",
    spend: "Spend",
    new_chat: "New chat",
    add_photo: "Add photo",
    title: "Title",
    price: "Price",
    nsfw: "NSFW",
    upload: "Upload",
    offer_photo: "Offer photo",
    no_fans_yet: "No fans yet.",
    no_messages: "No messages yet.",
    rules: "Persona rules",
    welcome_back: "Welcome back",
    enter_creator_panel: "Enter your creator panel",
    language: "Language",
  },
};

const I18nCtx = createContext({ t: (k) => k, lang: "en", setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("vue_lang") || "en");
  useEffect(() => localStorage.setItem("vue_lang", lang), [lang]);
  const t = (key) => dict[lang]?.[key] || dict.en[key] || key;
  return <I18nCtx.Provider value={{ t, lang, setLang }}>{children}</I18nCtx.Provider>;
}

export const useT = () => useContext(I18nCtx);
